"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plus = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Plus = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { width: "1.945", height: "18", x: "21", y: "11.028", fill: "currentColor", rx: "0.972", transform: "rotate(90 21 11.028)" }),
    react_1.default.createElement("rect", { width: "1.844", height: "18", x: "11.078", y: "3", fill: "currentColor", rx: "0.922" }))); };
exports.Plus = Plus;
//# sourceMappingURL=plus.js.map